module.exports = __webpack_public_path__ + "static/img/f2.d7d899f5.png";